$(document).ready(function () {
  function adjustScale() {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)
  }
  adjustScale();
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustScale, 100);
  });


  const mainSwiper = new Swiper('#swiper', {
    loop: true,
    centeredSlides: true,
    spaceBetween: 40,
    slidesPerView: 2.9,
    freeMode: true,
    speed: 5500, // 匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  });
  const swiperP1 = new Swiper('#swiper-p1', { speed: 1 });
//   const spSwiper2 = new Swiper('#sp-swiper2', {
//     autoplay: { disableOnInteraction: false },
//     spaceBetween: 0,
//     slidesPerView: 'auto',
//     centeredSlides: true,
//     loop: true,
//     pagination: { el: '.sp-pagination1', clickable: true },
//   });


  $('header').addClass('stiky');
  $(document).on('scroll', function () {
    setTimeout(() => $('header').addClass('stiky'), 50);
  });

  function generateRandomTime() {
    const hours = Math.floor(Math.random() * 15) + 1;
    const minutes = Math.floor(Math.random() * 60);
    const seconds = Math.floor(Math.random() * 60);
    return (hours * 3600 + minutes * 60 + seconds) * 1000;
  }
  function updateTimeDown(value) {
    const totalSeconds = Math.floor(value / 1000);
    const hours = totalSeconds < 0 ? 0 : Math.floor(totalSeconds / 3600);
    const minutes = totalSeconds < 0 ? 0 : Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds < 0 ? 0 : totalSeconds % 60;
    // 格式化两位数
    const strHours = hours < 10 ? '0' + hours : hours;
    const strMinutes = minutes < 10 ? '0' + minutes : minutes;
    const strSeconds = seconds < 10 ? '0' + seconds : seconds;
    // 输出
    $('.sp_hour').text(strHours);
    $('.sp_minute').text(strMinutes);
    $('.sp_second').text(strSeconds);
    // 如果时间没到0则递归调用
    if (totalSeconds > 0) {
      setTimeout(() => updateTimeDown(value - 1000), 1000);
    }
  }
  updateTimeDown(generateRandomTime());


  function lazyLoadImages() {
    const images = document.querySelectorAll('.lazy-load');
    const config = { rootMargin: '0px 0px 1300px 0px', threshold: 0 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const dataSrc = img.getAttribute('data-src');
          if (dataSrc) img.src = dataSrc;
          observer.unobserve(img);
        }
      });
    }, config);
    images.forEach((img) => observer.observe(img));
  }
  lazyLoadImages();

  $('a[href^="#shopping"]').on('click', function (e) {
    e.preventDefault();
    const targetElement = document.getElementById('shopping');
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".sp-header").height() + $("#swiper").height()-50;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
    }
  });

  function preloadImages(imageArray) {
    if (Array.isArray(imageArray) && imageArray.length) {
      if (Array.isArray(imageArray[0])) {
        imageArray.forEach((subArray) =>
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          })
        );
      } else {
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }
  }
  // preloadImages(imagesOneDim);
  // preloadImages(imagesTwoDim);

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);
  if (isAndroid) {
    console.log('Android');
  } else if (isIOS) {
    console.log('iOS');
  } else if (isPC) {
    console.log('PC');
  } else {
    $('.sp_system').css('letter-spacing', '-4px');
  }


  const products = window.product;
  function getCurrentProduct() {
    const color = $('#sp-color .active').attr('data-val');
    const size = $('#sp-num .active').attr('data-val');
    const adds = $('#sp-adds .active').attr('data-val');
    return products.find(
      (item) => item.option1 === color && item.option2 === size && item.option3 === adds
    );
  }
  function updatePrice() {
    const num = Number($('#calcNumber').val());
    const curProd = getCurrentProduct();
    if (curProd) {
      let price = ((curProd.price * num) / 100).toFixed(2);
      let compare = ((curProd.compare_at_price * num) / 100).toFixed(2);
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      $('#sp_price1').text(price);
      $('#sp_price2').text(compare);
    }
  }
  $('.sp-btn-style').on('click', function () {
    const num = $('#calcNumber').val();
    const curProd = getCurrentProduct();
    if (curProd) {
      window.location.href = '/cart/' + curProd.id + ':' + num;
    }
  });
  $('.sp-reduce').on('click', function () {
    const $input = $(this).siblings('input');
    let num = Number($input.val()) - 1;
    if (num > 0) {
      $input.val(num);
      updatePrice();
    }
  });
  $('.sp-add').on('click', function () {
    const $input = $(this).siblings('input');
    let num = Number($input.val()) + 1;
    $input.val(num);
    updatePrice();
  });
  $('.sp-option').on('click', function () {
    $(this).addClass('active').siblings().removeClass('active');
    updatePrice();
    // 根据选项调整 swiper
    const numOptions = $('#sp-num .active').index();
    const addsOptions = $('#sp-adds .active').index();
    swiperP1.slideTo(numOptions + addsOptions * 3);
  });
  if (window.cartCount > 0) {
    $('#cardNum').removeClass('sp-gray');
  }

  $('.cart-btn').on('click', function () {
    $(this).children('img').addClass('on');
    $('.sp-header-top .sp-cart .num').show();
    setTimeout(() => {
      $('.cart-btn img').removeClass('on');
    }, 500);
    $('.sp-header-top .sp-cart').addClass('on');
    setTimeout(() => {
      $('.sp-header-top .sp-cart').removeClass('on');
    }, 500);
  });
  $('.product-part .cart-btn').on('click', function () {
    const curProd = getCurrentProduct();
    if (!curProd) return;
    const data = { id: curProd.id, quantity: $('#calcNumber').val() };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('#cardNum').html(result.item_count).removeClass('sp-gray');
          $('#cardNum').removeClass('sp-gray');
        });
      },
    });
    // 克隆当前产品图片做动画效果
    var img = $(".product-part .swiper-slide-active .sp-img");
      // var img = $(".product-part .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");
    // const img = $('.product-part .swiper-slide-active .sp-img');
    // console.log(img)
    // const flyer = img.clone().addClass('sp_clone');
    $('.product-part').append(flyer);
    $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "9999",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top:
            finish[0].offsetTop +
            finish.height() / 2 +
            $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
  });
});
